import React, { useEffect, useState } from 'react'
import { LatestArticleCard } from '../cards/LatestArticleCard'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'

export const LatestArticlesSection = ({ nr }: { nr: number }) => {
  const { results, loadArticles } = useArticleTemplate({ pageSize: 3 })

  const [latestArticles, setLatestArticles] = useState(null)

  useEffect(loadArticles, [loadArticles])

  useEffect(() => {
    if (!latestArticles && results?.length) {
      setLatestArticles(results)
    }
  }, [results])

  return (
    <div className='flex flex-col flex-shrink-0 gap-[12px] lg:gap-[50px]'>
      <h1 className='font-bold text-lg md:text-2xl lg:text-[40px] text-[#001A3D]'>
        Latest
      </h1>
      {latestArticles?.slice(0, nr).map((article, idx) => (
        <LatestArticleCard key={'Latest' + idx} {...article} />
      ))}
    </div>
  )
}
